import React, { createContext, useContext, useReducer, useEffect, useRef, useState } from 'react';
import {
  loadGameLoungeState,
  saveGameLoungeState,
  subscribeGameLoungeState
} from '../appwrite/gameLoungeRepository';

const GameLoungeContext = createContext();

const DEFAULT_ROOMS = [
  {
    id: 'room-1',
    name: 'PC Raum 1',
    stations: [
      { id: 'pc-1-1', name: 'PC 1', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-1-2', name: 'PC 2', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-1-3', name: 'PC 3', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-1-4', name: 'PC 4', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-1-5', name: 'PC 5', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-1-6', name: 'PC 6', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-1-7', name: 'PC 7', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-1-8', name: 'PC 8', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 }
    ]
  },
  {
    id: 'room-2',
    name: 'PC Raum 2',
    stations: [
      { id: 'pc-2-1', name: 'PC 1', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-2-2', name: 'PC 2', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-2-3', name: 'PC 3', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-2-4', name: 'PC 4', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-2-5', name: 'PC 5', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-2-6', name: 'PC 6', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-2-7', name: 'PC 7', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-2-8', name: 'PC 8', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 }
    ]
  },
  {
    id: 'room-3',
    name: 'PC Raum 3',
    stations: [
      { id: 'pc-3-1', name: 'PC 1', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-3-2', name: 'PC 2', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-3-3', name: 'PC 3', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-3-4', name: 'PC 4', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-3-5', name: 'PC 5', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-3-6', name: 'PC 6', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-3-7', name: 'PC 7', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'pc-3-8', name: 'PC 8', type: 'pc', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 }
    ]
  },
  {
    id: 'room-4',
    name: 'PlayStation Raum',
    stations: [
      { id: 'playstation-4-1', name: 'PS 1', type: 'playstation', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'playstation-4-2', name: 'PS 2', type: 'playstation', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'playstation-4-3', name: 'PS 3', type: 'playstation', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'playstation-4-4', name: 'PS 4', type: 'playstation', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'playstation-4-5', name: 'PS 5', type: 'playstation', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 },
      { id: 'playstation-4-6', name: 'PS 6', type: 'playstation', status: 'available', startTime: null, customer: '', currentAmount: 0, isPaused: false, pausedAt: null, totalPausedTime: 0, endTime: null, finalAmount: 0, playTime: 0, controllerCount: 1 }
    ]
  }
];

const DEFAULT_KIOSK_ITEMS = [
  { id: 1, name: 'Hotdog Classic', price: 4.50, category: 'Snacks' },
  { id: 2, name: 'Pizza Margherita', price: 8.90, category: 'Pizza' },
  { id: 3, name: 'Pizza Salami', price: 9.90, category: 'Pizza' },
  { id: 4, name: 'Coca Cola 0.5L', price: 2.50, category: 'Getränke' },
  { id: 5, name: 'Energy Drink', price: 3.00, category: 'Getränke' },
  { id: 6, name: 'Nachos mit Käse', price: 5.50, category: 'Snacks' },
  { id: 7, name: 'Chicken Wings 6 Stück', price: 7.90, category: 'Snacks' }
];

const DEFAULT_SETTINGS = {
  pcHourlyRate: 8.00,
  playstationHourlyRate: 6.00,
  currency: '€'
};

const clone = (value) => JSON.parse(JSON.stringify(value));

const safeParse = (value, fallback) => {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.error('❌ Lokale Daten konnten nicht gelesen werden:', error);
    return fallback;
  }
};

const normalizeState = (state = {}) => ({
  rooms: Array.isArray(state.rooms) ? state.rooms : clone(DEFAULT_ROOMS),
  orders: Array.isArray(state.orders) ? state.orders : [],
  kioskItems: Array.isArray(state.kioskItems) ? state.kioskItems : clone(DEFAULT_KIOSK_ITEMS),
  settings: {
    ...DEFAULT_SETTINGS,
    ...(state.settings || {})
  }
});

const loadInitialState = () => {
  const savedState = safeParse(localStorage.getItem('gameLoungeState'), null);
  if (savedState) return normalizeState(savedState);

  return normalizeState({
    rooms: clone(DEFAULT_ROOMS),
    orders: safeParse(localStorage.getItem('gameLoungeOrders'), []),
    kioskItems: clone(DEFAULT_KIOSK_ITEMS),
    settings: safeParse(localStorage.getItem('gameLoungeSettings'), DEFAULT_SETTINGS)
  });
};

function gameLoungeReducer(state, action) {
  switch (action.type) {
    case 'HYDRATE_STATE':
      return normalizeState(action.payload);

    case 'START_SESSION':
      return {
        ...state,
        rooms: state.rooms.map(room => ({
          ...room,
          stations: room.stations.map(station => {
            if (station.id === action.payload.stationId) {
              const controllerCount = action.payload.controllerCount || 1;
              const baseRate = station.type === 'pc'
                ? state.settings.pcHourlyRate
                : state.settings.playstationHourlyRate;
              const rate = station.type === 'playstation' ? baseRate * controllerCount : baseRate;

              return {
                ...station,
                status: 'occupied',
                startTime: new Date().toISOString(),
                customer: action.payload.customer,
                controllerCount,
                currentAmount: rate,
                isPaused: false,
                pausedAt: null,
                totalPausedTime: 0,
                endTime: null,
                finalAmount: 0,
                playTime: 0
              };
            }
            return station;
          })
        }))
      };

    case 'PAUSE_SESSION':
      return {
        ...state,
        rooms: state.rooms.map(room => ({
          ...room,
          stations: room.stations.map(station =>
            station.id === action.payload.stationId
              ? {
                  ...station,
                  isPaused: true,
                  pausedAt: new Date().toISOString()
                }
              : station
          )
        }))
      };

    case 'RESUME_SESSION':
      return {
        ...state,
        rooms: state.rooms.map(room => ({
          ...room,
          stations: room.stations.map(station => {
            if (station.id === action.payload.stationId && station.isPaused) {
              const pauseDuration = new Date() - new Date(station.pausedAt);
              return {
                ...station,
                isPaused: false,
                pausedAt: null,
                totalPausedTime: station.totalPausedTime + pauseDuration
              };
            }
            return station;
          })
        }))
      };

    case 'STOP_SESSION':
      return {
        ...state,
        rooms: state.rooms.map(room => ({
          ...room,
          stations: room.stations.map(station => {
            if (station.id === action.payload.stationId) {
              const endTime = new Date();
              const startTime = new Date(station.startTime);
              const activeTime = endTime - startTime - station.totalPausedTime;

              return {
                ...station,
                status: 'completed',
                endTime: endTime.toISOString(),
                finalAmount: station.currentAmount,
                playTime: activeTime,
                isPaused: false,
                pausedAt: null
              };
            }
            return station;
          })
        }))
      };

    case 'RESET_STATION':
      return {
        ...state,
        rooms: state.rooms.map(room => ({
          ...room,
          stations: room.stations.map(station =>
            station.id === action.payload.stationId
              ? {
                  ...station,
                  status: 'available',
                  startTime: null,
                  endTime: null,
                  customer: '',
                  currentAmount: 0,
                  finalAmount: 0,
                  playTime: 0,
                  isPaused: false,
                  pausedAt: null,
                  totalPausedTime: 0,
                  controllerCount: 1
                }
              : station
          )
        }))
      };

    case 'UPDATE_CURRENT_AMOUNTS':
      return {
        ...state,
        rooms: state.rooms.map(room => ({
          ...room,
          stations: room.stations.map(station => {
            if (station.status === 'occupied' && station.startTime && !station.isPaused) {
              const now = new Date();
              const startTime = new Date(station.startTime);
              const diffMs = now - startTime - station.totalPausedTime;
              const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
              const completedHours = diffHours + 1;

              const baseRate = station.type === 'pc'
                ? state.settings.pcHourlyRate
                : state.settings.playstationHourlyRate;
              const rate = station.type === 'playstation' && station.controllerCount
                ? baseRate * station.controllerCount
                : baseRate;

              return {
                ...station,
                currentAmount: completedHours * rate
              };
            }
            return station;
          })
        }))
      };

    case 'ADD_ORDER':
      return {
        ...state,
        orders: [
          ...state.orders,
          {
            id: Date.now(),
            stationId: action.payload.stationId,
            items: action.payload.items,
            total: action.payload.total,
            timestamp: new Date().toISOString(),
            status: 'pending'
          }
        ]
      };

    case 'UPDATE_ORDER_STATUS':
      return {
        ...state,
        orders: state.orders.map(order =>
          order.id === action.payload.orderId
            ? { ...order, status: action.payload.status }
            : order
        )
      };

    case 'UPDATE_SETTINGS':
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.payload
        }
      };

    case 'ADD_KIOSK_ITEM':
      return {
        ...state,
        kioskItems: [
          ...state.kioskItems,
          { id: Date.now(), ...action.payload }
        ]
      };

    case 'UPDATE_KIOSK_ITEM':
      return {
        ...state,
        kioskItems: state.kioskItems.map(item =>
          item.id === action.payload.id
            ? { ...item, ...action.payload }
            : item
        )
      };

    case 'DELETE_KIOSK_ITEM':
      return {
        ...state,
        kioskItems: state.kioskItems.filter(item => item.id !== action.payload.id)
      };

    case 'ADD_ROOM':
      return {
        ...state,
        rooms: [
          ...state.rooms,
          {
            id: `room-${Date.now()}`,
            name: action.payload.name,
            stations: []
          }
        ]
      };

    case 'UPDATE_ROOM':
      return {
        ...state,
        rooms: state.rooms.map(room =>
          room.id === action.payload.roomId
            ? { ...room, name: action.payload.name }
            : room
        )
      };

    case 'DELETE_ROOM':
      return {
        ...state,
        rooms: state.rooms.filter(room => room.id !== action.payload.roomId)
      };

    case 'ADD_STATION_TO_ROOM':
      return {
        ...state,
        rooms: state.rooms.map(room => {
          if (room.id === action.payload.roomId) {
            const existingStationsOfType = room.stations.filter(s => s.type === action.payload.type);
            const stationNumber = existingStationsOfType.length + 1;
            const newStation = {
              id: `${action.payload.type}-${room.id}-${Date.now()}`,
              name: `${action.payload.type === 'pc' ? 'PC' : 'PS'} ${stationNumber}`,
              type: action.payload.type,
              status: 'available',
              startTime: null,
              customer: '',
              currentAmount: 0,
              isPaused: false,
              pausedAt: null,
              totalPausedTime: 0,
              endTime: null,
              finalAmount: 0,
              playTime: 0,
              controllerCount: 1
            };
            return {
              ...room,
              stations: [...room.stations, newStation]
            };
          }
          return room;
        })
      };

    case 'REMOVE_STATION_FROM_ROOM':
      return {
        ...state,
        rooms: state.rooms.map(room => {
          if (room.id === action.payload.roomId) {
            return {
              ...room,
              stations: room.stations.filter(station => station.id !== action.payload.stationId)
            };
          }
          return room;
        })
      };

    default:
      return state;
  }
}

export function GameLoungeProvider({ children }) {
  const [state, dispatch] = useReducer(gameLoungeReducer, undefined, loadInitialState);
  const [syncStatus, setSyncStatus] = useState('loading');
  const [syncError, setSyncError] = useState(null);
  const stateRef = useRef(state);
  const bootstrappedRef = useRef(false);
  const skipNextPersistRef = useRef(false);

  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  useEffect(() => {
    let mounted = true;

    const hydrateFromAppwrite = async () => {
      try {
        const remoteState = await loadGameLoungeState();

        if (!mounted) return;

        if (remoteState) {
          skipNextPersistRef.current = true;
          dispatch({ type: 'HYDRATE_STATE', payload: remoteState });
        } else {
          await saveGameLoungeState(stateRef.current);
        }

        bootstrappedRef.current = true;
        setSyncStatus('synced');
        setSyncError(null);
      } catch (error) {
        console.error('❌ Appwrite Initialisierung fehlgeschlagen:', error);
        bootstrappedRef.current = true;
        setSyncStatus('offline');
        setSyncError(error?.message || 'Appwrite konnte nicht initialisiert werden. Lokaler Fallback aktiv.');
      }
    };

    hydrateFromAppwrite();

    const unsubscribe = subscribeGameLoungeState((remoteState) => {
      if (!mounted || !bootstrappedRef.current) return;
      skipNextPersistRef.current = true;
      dispatch({ type: 'HYDRATE_STATE', payload: remoteState });
      setSyncStatus('synced');
      setSyncError(null);
    });

    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('gameLoungeState', JSON.stringify(state));
    localStorage.setItem('gameLoungeOrders', JSON.stringify(state.orders));
    localStorage.setItem('gameLoungeSettings', JSON.stringify(state.settings));
  }, [state]);

  useEffect(() => {
    if (!bootstrappedRef.current) return;

    if (skipNextPersistRef.current) {
      skipNextPersistRef.current = false;
      return;
    }

    setSyncStatus('saving');
    const timeout = setTimeout(async () => {
      try {
        await saveGameLoungeState(stateRef.current);
        setSyncStatus('synced');
        setSyncError(null);
      } catch (error) {
        console.error('❌ Appwrite Speicherung fehlgeschlagen:', error);
        setSyncStatus('offline');
        setSyncError(error?.message || 'Änderungen konnten nicht zu Appwrite synchronisiert werden.');
      }
    }, 400);

    return () => clearTimeout(timeout);
  }, [state]);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch({ type: 'UPDATE_CURRENT_AMOUNTS' });
    }, 60000);

    dispatch({ type: 'UPDATE_CURRENT_AMOUNTS' });

    return () => clearInterval(interval);
  }, []);

  return (
    <GameLoungeContext.Provider value={{ state, dispatch, syncStatus, syncError }}>
      {children}
    </GameLoungeContext.Provider>
  );
}

export function useGameLounge() {
  const context = useContext(GameLoungeContext);
  if (!context) {
    throw new Error('useGameLounge must be used within a GameLoungeProvider');
  }
  return context;
}
